import React from "react";

const OPTIONS = [
  { v: "30", label: "30d" },
  { v: "90", label: "90d" },
  { v: "365", label: "1y" },
  { v: "all", label: "All-time" },
];

export const WindowFilter = ({ window, setWindow, color }) => (
  <div className="inline-flex items-center rounded-full p-0.5 bg-zinc-950 border border-zinc-800" data-testid="window-filter">
    {OPTIONS.map((o) => {
      const active = o.v === window;
      return (
        <button
          key={o.v}
          onClick={() => setWindow(o.v)}
          data-testid={`window-${o.v}`}
          className="px-3 py-1 rounded-full text-xs font-semibold font-mono transition-colors duration-200"
          style={
            active
              ? { backgroundColor: color, color: "#09090b" }
              : { color: "#71717a" }
          }
        >
          {o.label}
        </button>
      );
    })}
  </div>
);
